import {isNotNilOrEmpty, Nullish} from 'shared/web';

type ItemNames = {
  name?: string | Nullish;
  nameForInvoice?: string | Nullish;
};

/**
 * Returns the name that invoices and printouts show for an item.
 * The back end prints `name` when `nameForInvoice` is null or "". A whitespace-only
 * `nameForInvoice` is printed as stored, so it is not treated as empty here.
 */
export const getInvoiceName = (item: ItemNames | Nullish) => {
  const nameForInvoice = item?.nameForInvoice;

  return isNotNilOrEmpty(nameForInvoice) ? nameForInvoice : (item?.name ?? null);
};
